import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from 'react-router-dom';
import store from './data/index';
import { currentBasename, syncLanguageFromUrl } from './common/langRouting';

// The URL prefix (/en, /ru, /am) is the source of truth for the site language.
// Sync localStorage to it and give the router a matching basename so every link
// keeps the prefix automatically.
syncLanguageFromUrl();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter basename={currentBasename()}>
      <App />
    </BrowserRouter>
  </Provider>
);